import * as Paths from "./paths";
import RootContainer from "../components/Root";
import DateRangeComparison from "../components/DateRangeComparison";
import AdsAndSmbs from "../components/AdsAndSmbs";
import WtdMtdQtd from "../components/WtdMtdQtd";
import { OrigamiAds, LegacyAds } from "../components/OrigamiAndLegacyAds";
import AdsPastSla from "../components/AdsPastSla";
import PixelTree from "../components/PixelTree";

export default [
  {
    title: "Home",
    path: Paths.ROOT_PATH,
    exact: true,
    strict: true,
    component: RootContainer,
  },
  {
    title: "Date Range Comparison",
    path: Paths.DATE_RANGE_COMPARISON_PATH,
    exact: true,
    strict: true,
    component: DateRangeComparison,
  },
  {
    title: "Ads And Smbs",
    path: Paths.ADS_AND_SMBS_PATH,
    exact: true,
    strict: true,
    component: AdsAndSmbs,
  },
  {
    title: "WTD/MTD/QTD",
    path: Paths.WTD_MTD_QTD_PATH,
    exact: true,
    strict: true,
    component: WtdMtdQtd,
  },
  {
    title: "Origami Ads",
    path: Paths.AD_TRACKER_ORIGAMI,
    exact: true,
    strict: true,
    component: OrigamiAds,
  },
  {
    title: "Legacy Ads",
    path: Paths.AD_TRACKER_LEGACY,
    exact: true,
    strict: true,
    component: LegacyAds,
  },
  {
    title: "Ads Past SLA",
    path: Paths.ADS_PAST_SLA,
    exact: true,
    strict: true,
    component: AdsPastSla,
  },
  {
    title: "Pixel Tree",
    path: Paths.PIXEL_TREE,
    exact: true,
    strict: true,
    component: PixelTree,
  },
];
